import React from 'react';
import AlimentBody from './body.tsx';
import AlimentHeader from './header.tsx';
import { useParams } from 'react-router-dom';
import { AlimentContextProvider } from '../../../contexts/aliments/aliment.tsx';

const Aliment = () => {
    const { id } = useParams();
    return (
        <AlimentContextProvider id={id}>
            <AlimentHeader />
            <AlimentBody />
        </AlimentContextProvider>
    );
};

export default Aliment;
